import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-6 mt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t border-gray-200" }, null, -1)
const _hoisted_4 = { class: "col-span-2" }

import { ref } from 'vue';

import SectionTitle from '@/components/partials/SectionTitle.vue';
import TextInput from '@/components/inputs/TextInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Array,
        required: true,
    },
    errors: {
        type: Array,
        required: true,
    }
},
  setup(__props) {

const props = __props

const form = ref<any>(props.form);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTitle, {
      fontSmall: "",
      title: "Field Option Information",
      description: "Relevant data and other details"
    }),
    _createElementVNode("form", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          type: "text",
          label: "Option Name",
          placeholder: "Option Name",
          name: "option_name",
          id: "option_name",
          modelValue: form.value.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
          error: __props.errors?.name
        }, null, 8, ["modelValue", "error"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})